import { prefixObjectValues } from '../utils';

const notFound = {
  title: 'title',
  goHome: 'go-home',
  contactSupport: 'contact-support',
};

export default prefixObjectValues(notFound, '404-not-found');
